import React from "react";
import clsx from "clsx";

interface LogoProps {
  linkTo?: string; // Optional link destination
  className?: string; // Additional custom classes
  variant?: "default" | "light"; // Variant for logo style
}

const Logo: React.FC<LogoProps> = ({
  linkTo, // Tidak ada default, sehingga opsional
  className, // Custom classes
  variant = "default", // Default variant
}) => {
  // Set the logo source based on the variant
  const logoSrc =
    variant === "light"
      ? "https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/jasa-bangun-rumah-arsinesia-logo-kecil.webp"
      : "https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/jasa-bangun-rumah-arsinesia-logo-black-kecil-2.webp";

  const logoImage = (
    <img
      className={clsx(
        "mr-[0.4rem] cursor-pointer", // Default styles that should not conflict with size
        className || "lg:w-[15rem] w-[10rem]" // Ensure `className` overrides defaults
      )}
      src={logoSrc}
      alt="Logo"
    />
  );

  return linkTo ? (
    <a href={linkTo}>{logoImage}</a>
  ) : (
    <div className="w-fit">{logoImage}</div>
  );
};

export default Logo;
